import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'row',
    },
    chartPieContainer: {
        maxWidth: '300px',
        maxHeight: '300px',
        margin: '10px',
    },
});
